var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"text-decoration":"underline","margin-bottom":"0"}},[_vm._v("Prévisualisation")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.results,"fields":_vm.fields.entete,"per-page":"5"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5abfd6d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/Import/Formater/PrevisualisationResults.vue
// module id = null
// module chunks = 